<template>
  <div :class="[listClass]">
    <slot
      name="errors"
      v-bind="{ items }"
    />
    <slot
      name="filter"
      v-bind="{ updateFilter, loadItems, items }"
    />
    <div
      ref="listWrapper"
      :style="[
        { height: calculatedHeight }
      ]"
      class="list-wrapper"
    >
      <slot v-if="!isMounted" />
      <template>
        <div class="events-group-list">
          <div
            v-for="group in groupedItems"
            :key="`group-${group.groupDate}`"
            class="events-group-item"
          >
            <div class="events-group-title">
              {{ formatDate(group.groupDate) }}
            </div>
            <div
              v-for="(item, index) in group.items"
              :key="`group-item-${item.eventId}-${index}`"
            >
              <slot
                name="card-template"
                v-bind="{ item, key: `card-${item.eventId}-group-${group.groupDate}` }"
              />
            </div>
          </div>
        </div>
      </template>
      <slot
        v-if="items.length === 0"
        name="no-items"
      />
    </div>
    <slot
      name="pagination"
      v-bind="{ pagination, defaultLimit, allLoaded }"
    />
  </div>
</template>

<script>
  import ListMixin from '@mixins/list-mixin'
  import { formatDateZone } from '@utils/date-helpers'

  export default {
    name: 'UpcomingEventsList',
    mixins: [ListMixin],
    computed: {
      groupedItems() {
        const groups = []
        let currentGroup = null

        this.items.forEach((item) => {
          if (!currentGroup || currentGroup.groupDate !== item.eventStartDate) {
            currentGroup = { groupDate: item.eventStartDate, items: [] }
            groups.push(currentGroup)
          }
          currentGroup.items.push(item)
        })

        return groups
      }
    },
    methods: {
      formatDate(date) {
        return formatDateZone(date, null, 'dddd, MMMM D')
      }
    }
  }
</script>
